import { Sprint } from "../Sprint"
import { Notification } from "./Notification"

export class NotificationRetrospective extends Notification {
  reminder: boolean
  sprint: Sprint

  constructor(props) {
    super(props)
    this.reminder = props.reminder
    this.sprint = new Sprint(props.sprint)
  }
}
